import React, {useEffect, useState} from 'react'
import { Form } from 'react-bootstrap'
import { createUser } from '../../api/api';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';
import { DeleteForever } from '@mui/icons-material';
const NewIDs = () => {

    const navigate = useNavigate()
    const [data, setData ] = useState({ });
    const [password, setPassword] = useState('');
    const [image, setImage] = useState();
    const [imageStatus, setImageStatus] = useState(false);
    const handleChange = (e) => {
        
        setData({ ...data, [e.target.name] : e.target.value});

    }

    const handleSubmit = async (e) => {
      e.preventDefault()
    //   window.start_load();
      // console.log('form submitted.');
      let formId = document.getElementById('newUser');
      const formData = new FormData(formId);
      const process = async () => {
        password == 'default' && formData.append('password', '0000');
        formData.append('file', image[0]);
        console.log(formData);
        const response = await createUser(formData);
        console.log(response);
        if(response.success){
            // Swal.fire('Success', response.message, 'success');///
            Swal.fire({
                title: 'Successful',
                icon:"success",
                text: response.message,
                closeButtonHtml: `<button className="btn btn-color"> Close </button>` 
            })
            setPassword('');
            setImage();
            e.target.reset();
        }else{
            // Swal.fire('Failed', response.message, 'error')
            Swal.fire({
                title: 'Failed',
                icon:"error",
                text: response.message,
                // showCloseButton: true,
                showConfirmButton: false,
                timer: 5000
                // closeButtonHtml: `<button className=" btn btn-color w-25"> Close </button>` 
            })
        }
      }
      if(password == 'custom'){
        if(formData.get('password') == formData.get('cpassword')){
            process();
        }else{
            Swal.fire({
                title: 'Warning',
                icon:"warning",
                text: 'Password does not match confirm password.',
                // showCloseButton: true,
                showConfirmButton: false,
                timer: 5000
                // closeButtonHtml: `<button className=" btn btn-color w-25"> Close </button>` 
            })
            
        }
      }else{
        process();
      }
    //   window.stop_load();
    }

    useEffect(() => {
        // console.log(data);
        document.title = 'New Staff IDs | Taste Place Investment'
    }, [])
    useEffect(() => {
        console.log(data);
    }, [data])
  return (
    <div className='m-1 px-2 py-5'
    style={{ 
        backgroundColor: 'whitesmoke',
        height: '99vh'
     }}
    >
        {/* <div className='d-flex justify-content-between mb-2'> */}
            <h4><b className=" mb-5"> {'New Staff ID(s)'} </b></h4> 
        {/* <button className='btn btn-md bg'><b> Generate IDs</b></button> */}
        {/* </div> */}
      <div className="card">
        <div className="card-body">
            
            <form action="" id="newUser"
            onSubmit={handleSubmit}
            >
                <div className="row justify-content-center">
                    <div className="col-md-6 card px-2 py-4">
                    <b className="text-muted"> Details </b>
                    
                        <div className="form-group mt-3">
                            <label className="control-label">No. of ID</label>
                            <input 
                            onChange={handleChange}
                            type="number" className="form-control form-control-sm" name="userId" placeholder='Amount of IDs to generate.'/>
                            
                        </div>
                        <div className="form-group mt-3">
                            <label for="" className="control-label"> Department/Unit </label>
                            <Form.Select 
                            onChange={handleChange}
                            size='sm' name="gender" id="gender" className="form-control">
                                <option value="" disabled>Select... </option>
                                <option value="1" >Restaurant </option>
                                <option value="0" >Kitchen</option>
                            </Form.Select>
                            <small><i></i></small>
                        </div>
                        <div className="d-flex justify-content-end mt-3">
                            <button
                            className="btn btn-color btn-lg ms-2"
                            // style={{ width: '120px' }}
                            >
                                <b> Generate </b>
                            </button>
                        </div>
                    </div>
                    {/* <div className='col-md-6'>
                        <h5 className='text-muted'> Generated IDs </h5>
                        <div className='form-group'>
                            <table className='table'>
                                <thead>
                                    <tr>
                                        <th> S/N </th>
                                        <th> UserId </th>

                                    </tr>
                                </thead>
                                <tbody>
                                    
                                </tbody>
                            </table>
                        </div>
                        <div className="d-flex justify-content-end">
                            <button
                            className="btn btn-color btn-md ms-2"
                            style={{ width: '120px' }}
                            >
                                <b> Print </b>
                            </button>
                        </div>	
                    </div> */}
                </div>
                <hr />
                <div className="col-lg-12  justify-content-end d-flex">
                     <button className="btn btn-danger btn-md" type="button" 
                     onClick={()=> {
                        navigate('/new_user');
                     }}
                     style={{ width: '120px' }}
                     >
                        <b>Close</b>
                     </button>
                      
                </div>
            </form>
        </div>
    </div>
    </div>
  )
}

export default NewIDs